import { Pipe, PipeTransform } from '@angular/core';
import { concatenateObjectFields } from '@epicuro-next/utilities';

@Pipe({
  name: 'concatenatedFields',
  pure: true,
  standalone: true,
})
export class ConcatenatedFieldsPipe implements PipeTransform {
  public transform<T extends object>(
    source: T,
    {
      fields = [],
      separator = '-',
      fieldsMap = {},
    }: {
      fields?: string[];
      separator?: string;
      fieldsMap?: Record<string, keyof T>;
    },
    defaultValue = '',
  ): string {
    return (
      concatenateObjectFields<T>(separator, source, fields, fieldsMap) ??
      defaultValue
    );
  }
}
